// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1ysUm","right":"styles_right__ajlWx"};